import { useQuery } from "@tanstack/react-query";
import { getTokenAsync } from "@coworker/app/src/hooks/API/getAuthToken";
import { jwtDecode } from "jwt-decode";
import {
  ATKOMST_BASIC_PERMISSION,
  AtkomstPermissions,
} from "../../shared/types/atkomstPermissions";
import type { JwtPayload } from "jwt-decode";

type AtkomstTokenMeta = string[];
type AtkomstTokenAuthorization = string;
const PLATFORM_OWNER = "PLATFORM_OWNER" as const;

const ATKOMST_TOKEN_AUTHORIZATION_CLAIM =
  "http://atkomst.ingka.com/authorizations" as const;
const ATKOMST_TOKEN_META_CLAIM = "http://atkomst.ingka.com/meta" as const;
const ATKOMST_TOKEN_PERMISSIONS_CLAIM =
  "http://atkomst.ingka.com/permissions" as const;

interface AtkomstToken extends JwtPayload {
  aio: string;
  azp: string;
  azpacr: string;
  email: string;
  [ATKOMST_TOKEN_AUTHORIZATION_CLAIM]: AtkomstTokenAuthorization;
  [ATKOMST_TOKEN_META_CLAIM]: AtkomstTokenMeta;
  [ATKOMST_TOKEN_PERMISSIONS_CLAIM]: AtkomstPermissions;
  ikealegacyuid: string;
  name: string;
  oid: string;
  preferredLanguage: string;
  preferred_username: string;
  rh: string;
  scp: string;
  sid: string;
  tid: string;
  uti: string;
  ver: string;
  xms_ccr: string[];
  xms_ftd: string;
  jti?: string;
}

const getUserHasRoleOnPlatformOwner = async () => {
  const token = await getTokenAsync();
  if (!token) {
    return false;
  }
  const decodedToken = jwtDecode<AtkomstToken>(token);
  return !!decodedToken[ATKOMST_TOKEN_AUTHORIZATION_CLAIM]?.includes(
    PLATFORM_OWNER
  );
};

const getUserHasFixaBasicPermissions = async () => {
  const token = await getTokenAsync();
  if (!token) {
    return false;
  }

  const decodedToken = jwtDecode<AtkomstToken>(token);
  return !!decodedToken[ATKOMST_TOKEN_PERMISSIONS_CLAIM]?.includes(
    ATKOMST_BASIC_PERMISSION
  );
};

const useUserHasRoleOnPlatformOwner = () =>
  useQuery({
    queryKey: ["userHasRoleOnPlatformOwner"],
    queryFn: getUserHasRoleOnPlatformOwner,
  });

const useUserHasFixaBasicPermissions = (enabled = false) =>
  useQuery({
    queryKey: ["userHasFixaBasicPermissions"],
    queryFn: getUserHasFixaBasicPermissions,
    enabled,
  });

export { useUserHasRoleOnPlatformOwner, useUserHasFixaBasicPermissions };
